import getFormatMessage from '../../../../locales/get-format-message';
import {
  CommonStatusStep,
  DownloadObjectType,
} from '../../../../model/api-modules';

export const getTypeOptions = (): {
  label: string;
  value: DownloadObjectType;
}[] => {
  const options: { label: string; value: DownloadObjectType }[] = [];
  options.push({
    label: 'Client',
    value: DownloadObjectType.Client,
  });
  options.push({
    label: 'Server',
    value: DownloadObjectType.Server,
  });
  options.push({
    label: 'Sample',
    value: DownloadObjectType.Sample,
  });
  options.push({
    label: 'Tools',
    value: DownloadObjectType.Tools,
  });
  return options;
};

export const getStatusTextVersion = (status: CommonStatusStep) => {
  switch (status) {
    case CommonStatusStep.Pending:
      return getFormatMessage('common_status_step_pending');
    case CommonStatusStep.Resolve:
      return getFormatMessage('common_status_step_active');
    case CommonStatusStep.Reject:
      return getFormatMessage('common_status_step_expired');
    default:
      return '-';
  }
};

export const getTypeName = (type: DownloadObjectType): string => {
  switch (type) {
    case DownloadObjectType.Client:
      return 'Client';
    case DownloadObjectType.Server:
      return 'Server';
    case DownloadObjectType.Sample:
      return 'Sample';
    case DownloadObjectType.Tools:
      return 'Tools';
    default:
      return '-';
  }
};
